import { render, staticRenderFns } from "./DlgPostsEdit.vue?vue&type=template&id=30571eff&scoped=true&"
import script from "./DlgPostsEdit.vue?vue&type=script&lang=ts&"
export * from "./DlgPostsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30571eff",
  null
  
)

export default component.exports